<template>
  <div class="artmisads-segmented-tabs">
    <div class="tabs-list">
      <!-- <div class="tab-title" v-if="showTitle">
        Program
      </div> -->
      <div
        v-for="(item, index) in items"
        :key="item.key"
        class="tab-item"
        :class="{
          active: modelValue === item.key,
          disabled: item.disabled
        }"
        @click="handleClick(item)"
      >
      <div class="tab-item-content">
        <Icon :name="item.icon" v-if="item.icon" class="icon"></Icon>
        {{ item.label }} 
        <a-popover placement="top"  v-if="type === 'payments'&&index === 1" >
        <template #content>
          <div class="tipContent"> 
            <p>Discrepancies between billing statements and</p>
            <p> report data may occur when Publishers submit</p> 
            <p> data across monthly cycles. Rest assured</p>  
            <p> that  all amounts are accurately accounted</p>  
            <p>for without duplication, with delayed entries</p> 
            <p>simply appearing in subsequent billing periods.</p>  
          </div>
        
         
        </template>
     
         <Icon name="wenhao-tianchong" class="icon"></Icon>
      </a-popover>
      </div>
    
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import Icon from '~/components/Icon.vue'

const props = defineProps({
  modelValue: {
    type: [String, Number],
    required: true
  },
  items: {
    type: Array,
    required: true,
    // [{key: string | number, label: string, disabled?: boolean}]
  },
  showTitle: {
    type: Boolean,
    default: true
  },
  disabled: {
    type: Boolean,
    default: false
  },
  type: {
    type: String,
    default: ''
  }
})

const emit = defineEmits(['update:modelValue', 'change'])

const handleClick = (item) => {
  if (item.disabled || props.disabled) return
  emit('update:modelValue', item.key)
  emit('change', item.key)
}
</script>

<style lang="less" scoped>
  :deep(.reject-reason-popover) {
    max-width: 320px;}
.artmisads-segmented-tabs {
  margin: 16px 0;
  border-bottom: 1px solid #E8E5ED;
  .tipContent{
   max-width: 500px;
  }
  .tabs-list {
    position: relative;
    bottom: -2px;
    .tab-title{
      font-family: "Sora";
      font-size: 15px;
      font-style: normal;
      font-weight: 400;
      margin-right: 18px;
    }
    display: flex;
    align-items: center;
    gap: 8px;
    // background: var(--bg-gray-6);
    padding: 2px;
    border-radius: 4px;
    width: fit-content;

    .tab-item {
      padding: 6px 16px;
      // font-size: var(--font-size-mormal);
      color: var(--dark-2);
      cursor: pointer;
      // border-radius: 4px;
      // transition: all 0.3s;
      background: transparent;
      border: none;
      position: relative;
      font-weight: 400;
      user-select: none;
      font-family: "Sora";
      font-size: 15px;
      .tab-item-content{
        display: flex;
        align-items: center;
        gap: 4px;
        .icon{
         margin-top: 3px;
        }
      }
      &:hover:not(.disabled) {
        color: var(--primary-hover);
      }

      &.active:not(.disabled) {
        // background: var(--color-white);
        color: var(--primary);
        font-weight: 600;
        border-bottom: 2px solid #6C3DF2;
      }

      &.disabled {
        cursor: not-allowed;
        color: var(--dark-4);
        opacity: 0.6;
      }
    }
  }

  .content {
    margin-top: 16px;
  }
}
</style> 